/**
 * Persistent anonymous visitor id. Lives in localStorage so the same visitor
 * is recognised across sessions. On login the backend's <c>/link-anonymous</c>
 * endpoint merges any UsageLog rows carrying this id into the user account.
 */
const KEY = 'ccms_anon_id';

export function getAnonymousId(): string {
  if (typeof window === 'undefined') return '';
  const existing = window.localStorage.getItem(KEY);
  if (existing) return existing;
  const fresh = generateUuid();
  try {
    window.localStorage.setItem(KEY, fresh);
  } catch {
    // Private browsing / storage full — fall through and return the in-memory id
    // so the session still produces a consistent AnonymousID for this page load.
  }
  return fresh;
}

function generateUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // RFC 4122 v4 fallback. Not cryptographically strong, but good enough for
  // anonymous-correlation ids.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
